import React from 'react';
import AnalizeClienti from './Analize';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';


export default class FacturiNeincasate extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        listFacturiTermen:[],
        listFacturiNeincasate:[]
}
    }

     componentDidMount(){
         this.getData()
    }

    getData = async() =>{
        let a = new AnalizeClienti()

        let data = await a.getFacturi();
        // console.log('data :', data);

        this.setState({listFacturiTermen:data.facturiInTermen,
                        listFacturiNeincasate:data.facturiTermenDepasit})

    

    }
     render() { 
       return (
          <div>
            <h1 className='pm-title'>{this.dictionary.financiarContabil.facturi}</h1>
                {this.state.listFacturiNeincasate.length>0 &&
                <div className='container'>

                    <h3 className='pm-title'>{this.dictionary.financiarContabil.facturiNeincasate}</h3>
                 <Table style={{ width: '90%', margin: 'auto' }}>
                 <TableHead>
                     <TableRow style={{}}>

                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.document}
                         </TableCell>
                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.termen}
                         </TableCell>
                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.total}
                         </TableCell>
                       


                     </TableRow>
                 </TableHead>

                 <TableBody>
                     {this.state.listFacturiNeincasate.map((l, idx) => {
                         return (
                             <TableRow  style={{ cursor: 'pointer' }} key={idx}>
                                 <TableCell style={{ textAlign: 'center' }}>
                                     {l.document}
                                 </TableCell>

                                 <TableCell style={{ textAlign: 'center' }} >
                                     {l.termen}
                                 </TableCell>
                                 <TableCell style={{ textAlign: 'center' }} >
                                     {l.total} lei
                                 </TableCell>
                              

                             </TableRow>
                         )
                     })}
                 </TableBody>
             </Table> 

             </div>
            }

             {this.state.listFacturiTermen.length>0 &&
             <div className='container'>
                  <h3 className='pm-title'>{this.dictionary.financiarContabil.facturiInTermen}</h3>
                 <Table style={{ width: '90%', margin: 'auto' }}>
                 <TableHead>
                     <TableRow style={{}}>

                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.document}
                         </TableCell>
                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.termen}
                         </TableCell>
                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.total}
                         </TableCell>
                       


                     </TableRow>
                 </TableHead>

                 <TableBody>
                     {this.state.listFacturiNeincasate.map((l, idx) => {
                         return (
                             <TableRow  style={{ cursor: 'pointer' }} key={idx}>
                                 <TableCell style={{ textAlign: 'center' }}>
                                     {l.document}
                                 </TableCell>

                                 <TableCell style={{ textAlign: 'center' }} >
                                     {l.termen}
                                 </TableCell>
                                 <TableCell style={{ textAlign: 'center' }} >
                                     {l.total} lei
                                 </TableCell>
                              

                             </TableRow>
                         )
                     })}
                 </TableBody>
             </Table> 

             </div>
            }

         </div>
        );
       }
}